import { useEffect, useState } from 'react';
import { readOfflineQueue, type OfflineMutationStatus } from '@/offline/offlineQueue';

export function useOfflineQueueCount(): number {
  const [count, setCount] = useState(() => pendingCount());

  useEffect(() => {
    function refresh() {
      setCount(pendingCount());
    }

    window.addEventListener('online', refresh);
    window.addEventListener('nangbook-offline-queue-changed', refresh);

    return () => {
      window.removeEventListener('online', refresh);
      window.removeEventListener('nangbook-offline-queue-changed', refresh);
    };
  }, []);

  return count;
}

export function useOfflineQueueSummary(): Record<OfflineMutationStatus, number> {
  const [summary, setSummary] = useState(() => summarize());

  useEffect(() => {
    function refresh() {
      setSummary(summarize());
    }

    window.addEventListener('online', refresh);
    window.addEventListener('nangbook-offline-queue-changed', refresh);

    return () => {
      window.removeEventListener('online', refresh);
      window.removeEventListener('nangbook-offline-queue-changed', refresh);
    };
  }, []);

  return summary;
}

function pendingCount(): number {
  return readOfflineQueue().filter((mutation) => mutation.status !== 'syncing').length;
}

function summarize(): Record<OfflineMutationStatus, number> {
  return readOfflineQueue().reduce<Record<OfflineMutationStatus, number>>(
    (summary, mutation) => ({ ...summary, [mutation.status]: summary[mutation.status] + 1 }),
    { queued: 0, syncing: 0, failed: 0, conflicted: 0 }
  );
}
